export enum EDocumentPageType {
  Unknown = 0,
  DocumentContent = 2,
  ContentLink = 3,
  Video = 4,
  Editor = 5,
}
